import React from "react";
import ReactPlayer from "react-player/lazy";
import PropTypes from "prop-types";
import { LazyComponent } from "../lazy-image";

const VideoPlayer = ({
    url,
    autoPlay,
    onEnded,
    playerRef,
    visibleByDefault = false,
    ...restProps
}) => {
    return (
        <LazyComponent visibleByDefault={visibleByDefault}>
            <ReactPlayer
                autoPlay={autoPlay}
                url={url}
                onEnded={onEnded}
                ref={playerRef}
                {...restProps}
            />
        </LazyComponent>
    );
};

VideoPlayer.propTypes = {
    url: PropTypes.string,
    autoPlay: PropTypes.bool,
    onEnded: PropTypes.func,
    playerRef: PropTypes.object,
    visibleByDefault: PropTypes.bool
};

export default VideoPlayer;
